export default {
  list: [
    {
      value: 'GROUND_LEVEL',
      title: 'همکف'
    },
    {
      value: 'BASEMENT',
      title: 'زیرزمین'
    },
    {
      value: 'UPSTAIR',
      title: 'طبقه بالا'
    }
  ],
  values: {
    GROUND_LEVEL: 'GROUND_LEVEL',
    BASEMENT: 'BASEMENT',
    UPSTAIR: 'UPSTAIR'
  }
};
